import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial
} from '../../../St/Reports/UseStyle';
export default function DiscountCodeForm(props) {
    const {
        rptParams,
        rptParamsAuto,
        onChangeAutoData,
        changTField,
        discType
    } = props;

    const { t } = useTranslation(["forms"]);
    const clasAo = useStylesAuto();

    const claslbl = useStylesLbl();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={4} md={4} sm={4} xs={3} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="id"
                        label={t("discount-code-no")}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                        // InputProps={{ className: clasTD.input, readOnly: true }}
                        type="text"
                        name="id"
                        value={rptParams.id}
                    />
                </Grid>
                <Grid item lg={8} md={8} sm={8} xs={9} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("discount-code")}
                        type="text"
                        name="name"
                        value={rptParams.code}
                        InputLabelProps={{ className: claslbl.clrBlackLblS,}}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("code")}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto?.type}
                        onChange={(event, newValue) => {
                            onChangeAutoData("type", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={discType}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : (option?.name ? t(option.name) : "")
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("discount-type")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("discount-amount")}
                        type="number"
                        name="name"
                        value={rptParams.monay}
                        disabled={rptParams.type==2}
                        InputLabelProps={{className: claslbl.clrBlackLblS,}}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("monay")}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("discount")}
                        type="number"
                        name="name"
                        value={rptParams.rate}
                        disabled={rptParams.type==1}
                        InputLabelProps={{className: claslbl.clrBlackLblS,}}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("rate")}
                    />
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={6} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("start-date")}
                        type="date" format="YYYY-MM-DD"
                        name="name"
                        value={rptParams.start_date}
                        InputLabelProps={{className: claslbl.clrBlackLblS,}}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("start_date")}
                    />
                </Grid>
                
                <Grid item lg={6} md={6} sm={6} xs={6} style={{marginBottom:"0.5rem"}}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("end-date")}
                        type="date" format="YYYY-MM-DD"
                        name="name"
                        value={rptParams.end_date}
                        InputLabelProps={{className: claslbl.clrBlackLblS,}}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        onChange={changTField("end_date")}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
